'use client';

import React, { useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import styles from './titleNavContainer.module.scss';
import SectionPanel from './sectionPanel';
import { useTrack } from '@chewy/use-analytics';
import { useParams } from 'next/navigation';

export interface TitleNavContainerProps {
  readonly dataItems: any[];
}

const TitleNavContainer = ({ dataItems }: TitleNavContainerProps) => {
  const params = useParams();
  const id = useMemo(() => params.id as string[] | string, [params.id]);
  const track = useTrack();

  useEffect(() => {
    if ( !id || !track) {
      return;
    }
    const eventProperties = {
      id: 'title-nav-container-viewed-id',
      parentId: id,
      level: 'help-center',
      type: 'section',
      position: 1,
      event_name: 'Widget Viewed',
      eventAction: 'impression',
      eventCategory: 'help-center-landing-page',
      eventLabel: 'help-center-landing-page-topics-view',
      name: 'Popular Topics Widget Viewed'
    };
    track('Title Nav Container Viewed', eventProperties);
  }, [track, id]);


  if (isEmpty(dataItems)) {
    return null;
  }

  return (
    <div role="main" aria-label="Help Center Topics" className={styles.titleNavContainer}>
      {map(dataItems, (dataItem: any) => (
        <section key={dataItem.id} className={styles.popularTopicsSection} role="region" aria-labelledby={`section-${dataItem.id}`}>
          <h2 id={`section-${dataItem.id}`} className={styles.sectionTitle}>{dataItem.title}</h2>
          {!isEmpty(dataItem?.sections) && (
            <ul className={styles.linkList} role="list" aria-labelledby={`section-${dataItem.id}`} aria-label={`${dataItem.title} topics`}>
              {map(dataItem?.sections, (section: any) => (
                <SectionPanel key={section?.id} section={section} />
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
};

export default TitleNavContainer;
